module.exports = __webpack_public_path__ + "stylesheets/template-pages-list_9fe1e728eb72618ba274b6ab4804ca0c.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/template-pages-list.less
// module id = R8wy
// module chunks = 151